import * as ambassadorWixDevcenterScriptsV1ScriptProperties from './devcenter-scripts-v1-script-properties-embedded-scripts.http.js';
import * as ambassadorWixDevcenterScriptsV1ScriptPropertiesTypes from './devcenter-scripts-v1-script-properties-embedded-scripts.types.js';
import * as ambassadorWixDevcenterScriptsV1ScriptPropertiesUniversalTypes from './devcenter-scripts-v1-script-properties-embedded-scripts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function embedScript(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDevcenterScriptsV1ScriptPropertiesUniversalTypes.EmbedScriptRequest,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesTypes.EmbedScriptRequest,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesUniversalTypes.EmbedScriptResponse,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesTypes.EmbedScriptResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDevcenterScriptsV1ScriptProperties.embedScript(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/scripts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEmbeddedScript(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDevcenterScriptsV1ScriptPropertiesUniversalTypes.GetEmbeddedScriptRequest,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesTypes.GetEmbeddedScriptRequest,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesUniversalTypes.GetEmbeddedScriptResponse,
  ambassadorWixDevcenterScriptsV1ScriptPropertiesTypes.GetEmbeddedScriptResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDevcenterScriptsV1ScriptProperties.getEmbeddedScript(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/scripts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ScriptProperties as ScriptPropertiesOriginal,
  EmbedScriptRequest as EmbedScriptRequestOriginal,
  EmbedScriptResponse as EmbedScriptResponseOriginal,
  GetEmbeddedScriptRequest as GetEmbeddedScriptRequestOriginal,
  GetEmbeddedScriptResponse as GetEmbeddedScriptResponseOriginal,
  EmbedScriptByInstanceIdRequest as EmbedScriptByInstanceIdRequestOriginal,
  GetEmbeddedScriptByInstanceIdRequest as GetEmbeddedScriptByInstanceIdRequestOriginal,
} from './devcenter-scripts-v1-script-properties-embedded-scripts.types.js';
